import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import PlanCard from './components/PlanCard';
import { connect } from 'react-redux';
import { withOktaAuth } from '@okta/okta-react';
import { Redirect, withRouter, Link } from 'react-router-dom';
import ChangeIcon from 'mdi-react/RotateLeftIcon';
import FreeAccount from './components/FreeAccount';

import TopBar from './../../TopBar'
import Footer from './../../Footer'

import './../Payment.scss'

import { subscriptionPlans } from './../plans.js';

	
class PricingCards extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
	  const { user } = this.props;
	  
	 
	  
	  let currentPlan = user && user.subscriptionPlan ? subscriptionPlans.filter(subPlan => subPlan.stripeProductId === user.subscriptionPlan)[0] : false;
	  
	  if(user && user.role && (user.role.indexOf("enterprise")>=0 || user.role.indexOf("admin")>=0)){
		  currentPlan = subscriptionPlans.filter(subPlan => subPlan.id === "enterprise")[0]
	  }
	  return (
		 	<div className="plan__wrapper share__wrapper">
			  <TopBar />
			  <FreeAccount />
			  <Container className="plan__container">			   
			    <Row>
			      <Col md={12}>
			        <h3 className="page-title">Pricing Plans
			        
			        </h3>
			        <h3 className="page-subhead subhead">
			        	Choose the best plan for your needs
			        	{currentPlan &&
				        	<span style={{float:"right",fontSize:13}}>
				        		<a href="/dashboard" className="link-text"><ChangeIcon size={13} /> My Dashboard</a>
				        		</span>
						}
			        </h3>
			        
			      </Col>
			    </Row>
			    <Row>
			    {subscriptionPlans.filter(plan => !plan.hideOnPricingPage).map(plan => {
				    return <PlanCard plan={plan} user={user} currentPlan={currentPlan} />
			    })}
			    </Row>
			  </Container>
			  <Footer />
			</div>
		)
   }
};
export default connect(state => ({
  user: state.user,
  plan: state.plan
}))(withOktaAuth(PricingCards));
